a.s.datetimerangepicker = function () {
	var dtrpobj = {};
	dtrpobj.el = undefined;
	dtrpobj.timeformat = '24h';
	dtrpobj.highlightedDays = [];
	dtrpobj.calendar_width = 745;
	dtrpobj.start_datetime = undefined;
	dtrpobj.end_datetime = undefined;
	dtrpobj.mindate = undefined; // Invalid in app
	dtrpobj.past_select = true;
	dtrpobj.inputname = undefined;
	dtrpobj.output_start = undefined;
	dtrpobj.output_end = undefined;
	dtrpobj.valid_output = false;
	dtrpobj.picker = undefined;
	dtrpobj.ready = function(){};
	dtrpobj.change = function(){};
	dtrpobj.dpid = 'datepickerc_'+Math.random().toString(36).substr(2);
	dtrpobj.insert = function(){
		tpl.run({tpl:'/tpl/shared/datetimerangepicker/main.ejs?v='+v,data:{
			dpid:dtrpobj.dpid,
			inputname:dtrpobj.inputname,
			datetime:dtrpobj.datetime,
			allow_past_date:dtrpobj.allow_past_date,
			timeformat:dtrpobj.timeformat,
			calendar_width:dtrpobj.calendar_width
		},cb:function(content){
			$(dtrpobj.el).empty().append(content);
			// Calendar
			var calendar_el = document.getElementById(dtrpobj.dpid);
			var picker = new TavoCalendar(calendar_el, {
                date: dtrpobj.start_datetime.toISOString(),
                date_start: dtrpobj.start_datetime.toISOString(),
                date_end: dtrpobj.end_datetime.toISOString(),
                past_select:dtrpobj.past_select,
                format: "YYYY-MM-DD",
                locale: "en",
                range_select: true
            });
            calendar_el.addEventListener('calendar-range', (ev) => {
			    var range = picker.getRange();
			    if (typeof(range.start)!=='undefined' && typeof(range.end)!=='undefined') {
					dtrpobj.updateStartDate(range.start);
					dtrpobj.updateEndDate(range.end);
					dtrpobj.updateOutput(range.start,range.end);
				}
				else {
					dtrpobj.valid_output=false;
					dtrpobj.reset();
				}
			});

			/*var picker = new Litepicker({
				element: document.getElementById(dtrpobj.dpid),
				inlineMode: true,
				singleMode: false,
				numberOfColumns: 2,
				numberOfMonths:2,
				showTooltip:false,
				highlightedDays:dtrpobj.highlightedDays,
				minDate:dtrpobj.mindate?dtrpobj.mindate:undefined,
				dropdowns:{"minYear":2010,"maxYear":null,"months":true,"years":true},
				setup:function(picker){
					picker.on('preselect',function(start,end){
						if (typeof(start)!=='undefined' && typeof(end)!=='undefined') {
							dtrpobj.updateStartDate(start.dateInstance.toISOString());
							dtrpobj.updateEndDate(end.dateInstance.toISOString());
							dtrpobj.updateOutput(start.dateInstance.toISOString(),end.dateInstance.toISOString());
						}
						else {
							dtrpobj.valid_output=false;
							dtrpobj.reset();
						}
					});
				}
			});*/
			dtrpobj.picker = picker;
			if (typeof(dtrpobj.start_datetime)=='object'&&typeof(dtrpobj.end_datetime)=='object') {
				picker.setRange(dtrpobj.start_datetime,dtrpobj.end_datetime);
				//picker.gotoDate(dtrpobj.start_datetime);
				if (dtrpobj.timeformat=='24h') {
					$('select[name="hour_start"]>option[value="'+dtrpobj.start_datetime.getHours().toString().padStart(2,0)+'"]',dtrpobj.el).prop('selected',true);
					$('select[name="minute_start"]>option[value="'+dtrpobj.start_datetime.getMinutes().toString().padStart(2,0)+'"]',dtrpobj.el).prop('selected',true);
					$('select[name="hour_end"]>option[value="'+dtrpobj.end_datetime.getHours().toString().padStart(2,0)+'"]',dtrpobj.el).prop('selected',true);
					$('select[name="minute_end"]>option[value="'+dtrpobj.end_datetime.getMinutes().toString().padStart(2,0)+'"]',dtrpobj.el).prop('selected',true);
				}
				else {
					var startArray = dtrpobj.formatAMPM(dtrpobj.start_datetime);
					var endArray = dtrpobj.formatAMPM(dtrpobj.end_datetime);
					$('select[name="hour_start"]>option[value="'+startArray.hours+'"]',dtrpobj.el).prop('selected',true);
					$('select[name="minute_start"]>option[value="'+startArray.minutes+'"]',dtrpobj.el).prop('selected',true);
					$('select[name="ampm_start"]>option[value="'+startArray.ampm+'"]',dtrpobj.el).prop('selected',true);
					$('select[name="hour_end"]>option[value="'+endArray.hours+'"]',dtrpobj.el).prop('selected',true);
					$('select[name="minute_end"]>option[value="'+endArray.minutes+'"]',dtrpobj.el).prop('selected',true);
					$('select[name="ampm_end"]>option[value="'+endArray.ampm+'"]',dtrpobj.el).prop('selected',true);
				}
				dtrpobj.updateStartDate(dtrpobj.start_datetime);
				dtrpobj.updateEndDate(dtrpobj.end_datetime);
				dtrpobj.changeTime();
			}
			// Bind time dropdowns
			$('select[name="hour_start"],select[name="minute_start"],select[name="hour_end"],select[name="minute_end"],select[name="ampm_start"],select[name="ampm_end"]',dtrpobj.el).unbind('change').change(function(){
				dtrpobj.changeTime();
			});
			dtrpobj.ready();
		}});
	}
	dtrpobj.changeTime = function(){
		var start = new Date(dtrpobj.picker.getStartDate());
		var end = new Date(dtrpobj.picker.getEndDate());
		if (start!==null&&end!==null) {
			dtrpobj.updateOutput(start.toISOString(),end.toISOString());
		}
		else {
			dtrpobj.valid_output=false;
		}
	}
	dtrpobj.updateStartDate = function(date){
		$('[data-area="startdatestr"]',dtrpobj.el).empty().append(moment(date).format("LL"));
	}
	dtrpobj.updateEndDate = function(date){
		$('[data-area="enddatestr"]',dtrpobj.el).empty().append(moment(date).format("LL"));
	}
	dtrpobj.updateOutput = function(start,end){
		var dateformat = "YYYY-MM-DD h:mm A";
		if (dtrpobj.timeformat=='24h') {
			dateformat = "YYYY-MM-DD HH:mm";
		}
		// Check if, and correct if needed, that end is after start
		if (dtrpobj.timeformat=='12h') {
			var start = moment(start).format('YYYY-MM-DD')+' '+$('select[name="hour_start"]',dtrpobj.el).val()+':'+$('select[name="minute_start"]',dtrpobj.el).val()+':00 '+$('select[name="ampm_start"]',dtrpobj.el).val().toUpperCase();
			var end = moment(end).format('YYYY-MM-DD')+' '+$('select[name="hour_end"]',dtrpobj.el).val()+':'+$('select[name="minute_end"]',dtrpobj.el).val()+':00 '+$('select[name="ampm_end"]',dtrpobj.el).val().toUpperCase();
		}
		else {
			var start = moment(start).format('YYYY-MM-DD')+' '+$('select[name="hour_start"]',dtrpobj.el).val()+':'+$('select[name="minute_start"]',dtrpobj.el).val()+':00';
			var end = moment(end).format('YYYY-MM-DD')+' '+$('select[name="hour_end"]',dtrpobj.el).val()+':'+$('select[name="minute_end"]',dtrpobj.el).val()+':00';
		}
		var duration = moment.duration(moment(end,[dateformat]).diff(moment(start,[dateformat])));
		if (duration.asSeconds()>0) {
			dtrpobj.output_start = moment(start,[dateformat]).format('YYYY-MM-DD HH:mm:ss');
			dtrpobj.output_end = moment(end,[dateformat]).format('YYYY-MM-DD HH:mm:ss');
			dtrpobj.updateDuration();
			dtrpobj.valid_output=true;
			dtrpobj.change();
		}
		else {
			// Invalid range
			dtrpobj.valid_output=false;
			dtrpobj.markInvalid();
			dtrpobj.change();
		}
	}
	dtrpobj.updateDuration = function(){
		if (typeof(dtrpobj.output_start)!=='undefined' && typeof(dtrpobj.output_end)!=='undefined') {
			var start = moment(dtrpobj.output_start);
			var end = moment(dtrpobj.output_end);
			var duration = moment.duration(end.diff(start));
			//Get Days and subtract from duration
			var days = Math.floor(duration.asDays());
			duration.subtract(moment.duration(days,'days'));
			//Get hours and subtract from duration
			var hours = duration.hours();
			duration.subtract(moment.duration(hours,'hours'));
			//Get Minutes and subtract from duration
			var minutes = duration.minutes();
			duration.subtract(moment.duration(minutes,'minutes'));
			// Update duration
			$('[data-area="duration_days"]',dtrpobj.el).text(days+(days==1?' day':' days'));
			$('[data-area="duration_hm"]',dtrpobj.el).text(hours+'h '+minutes+'m');
		}
	}
	dtrpobj.reset = function(){
		dtrpobj.output_start=undefined;
		dtrpobj.output_end=undefined;
		$('[data-area="duration_days"]',dtrpobj.el).text('N/A');
		$('[data-area="duration_hm"]',dtrpobj.el).text('');
		dtrpobj.change();
	}
	dtrpobj.markInvalid = function(){
		$('[data-area="duration_days"]',dtrpobj.el).html('<span style="color:red;">Invalid range</span>');
		$('[data-area="duration_hm"]',dtrpobj.el).text('');
	}
	dtrpobj.formatAMPM = function(date) {
		var hours = date.getHours();
		var minutes = date.getMinutes();
		var ampm = hours >= 12 ? 'pm' : 'am';
		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'
		return {
			hours:hours.toString().padStart(2,0),
			minutes:minutes.toString().padStart(2,0),
			ampm:ampm
		};
	}
	return dtrpobj;
}